<template>
  <div class="header-box">
    <div class="header-left">
      <div class="logo clearfix">
        <div class="fl">
          <img src="../assets/logo_ld.png"
               alt="">
        </div>
        <div class="fl">
          <div class="logoTitle">魔镜增长雷达</div>
          <div class="logoText">MKTINDEX.COM</div>
        </div>
        <div class="fl">
          <el-popover placement="bottom-start"
                      trigger="hover">
            <div>
              <img style="width: 200px"
                   src="../assets/kf.jpeg"
                   alt="">
            </div>
            <div style="text-align:center;">扫码联系售后人员</div>
            <i class="iconfont icon-kefu kf"
               slot="reference"><span class="text">售后支持</span></i>
          </el-popover>
        </div>
      </div>
    </div>
    <div class="header-right">
      <div class="myAtention"
           v-show="false">
        <i class="iconfont icon-heart-fill"
           style="color:#FF7875 ;margin-right:12px"></i>
        <span class="headText">{{$t('topHead.my_attention')}}</span>
      </div>
      <userinfo @userLogin="userLoginValue"> </userinfo>

      <div class="language">
        <span @click="changeLanguge('zh')"
              :class="{'selected': localS.getItem('language')=='zh'}">{{$t('topHead.Chinese')}}</span>
        <el-divider direction="vertical"></el-divider>
        <span @click="changeLanguge('en')"
              :class="{'selected': localS.getItem('language')=='en'}">{{$t('topHead.English')}}</span>
      </div>
    </div>

  </div>
</template>

<script>
import { userinfo } from 'common'
import { parseTime, getUrlParams, getObjFromUrl } from '@/utils'
const localS = localStorage
export default {
  components: {
    userinfo,
  },
  data() {
    return {
      localS,
      cid: this.$store.state.user.cat_id,
      cat: '',
      catName: this.$store.state.user.cat_name,
      loginInfo: {},
      ts: '',
      isEbay: false,
    }
  },
  methods: {
    userLoginValue(val) {
      this.loginInfo = val
      let { cid, ts } = this.rand_cat(val.cat_list)
      this.ts = ts
      this.$store.dispatch('user/changeName', val.username)
      this.$store.dispatch('user/changeEbayCId', cid)
      this.$store.dispatch('user/changeEbayTs', ts)
    },
    rand_cat(catlist) {
      if (catlist == 'all') {
        let ts = ''
        if (getUrlParams('ebayTs')) {
          ts = getUrlParams('ebayTs')
          localStorage.setItem('ebayTs', getUrlParams('ebayTs'))
          return { cid: getUrlParams('ebayCId'), ts: getUrlParams('ebayTs') }
        } else {
          ts = localStorage.getItem('ebayTs')
        }
        return { cid: getUrlParams('ebayCId'), ts: ts }
      }
      var cid = ''
      var ts = ''
      Object.keys(catlist).forEach((item) => {
        let v = catlist[item]
        if (v.length > 0 && !cid) {
          cid = v[0]['cat_id']
        }
        if (v.length > 0 && !ts) {
          ts = v[0]['ts']
        }
      })
      localStorage.setItem('ebayCId', cid)
      localStorage.setItem('ebayTs', ts)
      return { cid: cid, ts: ts }
    },
    handleRemove(key) {},
    changeLoginState(val) {},
    /*
     type:查询类型  id:通过id精确查询，name：通过名称模糊查询
    */
    //切换语言
    changeLanguge(lan) {
      // this.$i18n.locale = lan
      localStorage.setItem('language', lan)
      location.reload()
    },
  },
  watch: {
    '$store.state.user.ebayCId': {
      handler(newVal, oldVal) {
        this.cat = newVal
      },
    },
    '$store.state.user.ebayCName': {
      handler(newVal, oldVal) {
        this.catName = newVal
      },
    },
    '$store.state.user.ebayWord': {
      handler(newVal, oldVal) {
        this.keyWards = newVal.replace(new RegExp('&amp;', 'g'), '&')
      },
    },
  },
  created() {
    // this.getBrands(this.$store.state.user.selectedType)
  },
}
</script>

<style scoped lang='less'>
.header-box {
  align-items: normal !important;
}
.header-left {
  color: #ff7d00;
  .lb {
    display: inline-block;
  }
  .logo {
    img {
      height: 35px;
      margin-top: 10px;
      margin-right: 12px;
    }
    .fl {
      float: left;
    }
    .fr {
      float: right;
    }
    .logoTitle {
      font-size: 24px;
      font-family: sans-serif;
      font-weight: bold;
      color: #ff7d00;
      margin-top: 8px;
      line-height: 30px;
    }
    .logoText {
      font-size: 12px;
      font-family: sans-serif;
      color: #ff7d00;
      transform: scale(0.7);
      text-align: center;
      line-height: 10px;
    }
  }
  .kf {
    margin-left: 30px;
    cursor: pointer;
    line-height: 56px;
    font-size: 24px;
  }
  .text {
    display: inline-block;
    font-size: 14px;
    vertical-align: top;
    margin-left: 4px;
  }
}
.catSearch {
  /deep/ input {
    width: 120px;
    height: 32px;
    background-color: #ff7d00;
    color: #fff;
    border-radius: 4px 0px 0px 4px;
  }
}
</style>
